import React from 'react'
import Breadcrumb from '../BreadCrumb/BreadCrumb'
import HomeContact from '../container/HomeContainer/HomeContact'
import FacilityContainer from '../container/PagesContainer/FacilityContainer'
import Footer from '../footer/Footer'
import MainNavigation from '../nav/MainNavigation'
import SEO from '../SEO/SEO'


function Facilities() {
    return (
        <React.Fragment>
            <SEO title="Dr Bupathi Gastro and Laparoscopy || Facilities" />
            <MainNavigation />
            <Breadcrumb image="/images/pages/Facilities.jpg" title="Home" content="Facilities" />
            <FacilityContainer />
            <HomeContact />
            <Footer />
        </React.Fragment>
    )
}

export default Facilities